const state = {
  languagesStore:
    [
      {
        id: 1,
        title_en: "English",
        title_ua: "Англійська",
        title_es: "Inglés",
        regnumber: "Upper-Intermediate",
        grade_en: "Successfully completed",
        grade_ua: "Успішно завершено",
        grade_es: "Completado con éxito",
        examdate: "14.02.2022",
        image: "https://www.englishdom.com/cn/fbc6541a",
      },
      {
        id: 2,
        title_en: "Spanish",
        title_ua: "Іспанська",
        title_es: "Español",
        regnumber: "Upper-Intermediate",
        grade_en: "Successfully completed",
        grade_ua: "Успішно завершено",
        grade_es: "Completado con éxito",
        examdate: "05.08.2016",
        image: "/assets/documents/spanish.webp",
      }
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};